import { SchedulingAttendanceSummaryTag } from "@clockwise/schema";
import classNames from "classnames";
import React from "react";
import { getFormattedTag } from "./utils/getFormattedTag";

export const TagTitle = ({
  tags,
  index,
  isSelected,
  numImpacts,
  justIcon = false,
}: {
  tags: SchedulingAttendanceSummaryTag[];
  index: number;
  isSelected: boolean;
  numImpacts: number;
  justIcon?: boolean;
}) => (
  <div
    className={classNames("cw-body-sm cw-font-bold", {
      "cw-text-positive": numImpacts === 0 && !isSelected,
      "cw-text-warning": numImpacts > 0 && !isSelected,
      "cw-text-onEmphasis": isSelected,
    })}
  >
    {justIcon ? getFormattedTag(tags, index).icon : getFormattedTag(tags, index).full}
  </div>
);
